import quickFetch from 'quick-fetch';
import { isHubteamDomain } from '../utils/isHubteamDomain';

const appAuthSegment = (): Promise<string> => {
  if (!quickFetch.getLoginVerifyRequest()) {
    return Promise.reject(Error('quickFetch login-verify not available'));
  }

  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      const err = Error('quickFetch afterAuth timed out');
      reject(err);
    }, 20_000);

    quickFetch.afterAuth((auth: any) => {
      clearTimeout(timeout);

      const portalId = auth?.portal?.portal_id;
      const userId = auth?.user?.user_id;

      if (portalId == null || userId == null) {
        reject(Error('quickFetch auth missing portalId or userId'));
        return;
      }

      resolve(`${portalId}/${userId}`);
    });
  });
};

const janusSegment = (): Promise<string> =>
  import('hub-http-janus/userInfo').then(({ safeGetUsername }) => {
    const username = safeGetUsername();
    if (!username) {
      return Promise.reject(
        Error('Janus username not available — hs_tools_auth cookie missing')
      );
    }
    return `janus/${username}`;
  });

export const getSegment = (): Promise<string> | null => {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return null;
  }

  return isHubteamDomain() ? janusSegment() : appAuthSegment();
};
